// src/components/Header.js
import React, { useState } from 'react';
import Navbar from './Navbar';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import TopBar from './TopBar';

const Header = () => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  return (
    <>
      <TopBar />
      <header className="landing-header stratos-banner">
        <div className="stratos-container">
          <Navbar onQuoteClick={() => setShowQuoteModal(true)} />
          {showQuoteModal && <Modal onClose={() => setShowQuoteModal(false)} />}
          
          <div className="stratos-hero">
            <div className="stratos-content-centered">
              <h1 className="stratos-title">Strategic Financial Solutions</h1>
              <h2 className="stratos-subtitle">We are here for you.</h2>
              <p className="stratos-description">
                Are you looking to elevate your business finances, optimize your tax strategy,
                or ensure compliance with evolving regulations? Our team of experts provides
                tailored solutions to help you navigate the complex financial landscape.
              </p>
              <div className="stratos-actions">
                <button
                  className="stratos-btn stratos-btn-primary"
                  onClick={() => setShowQuoteModal(true)}
                >
                  Contact Us
                </button>
                <Link to="/services" className="stratos-btn stratos-btn-secondary">
                  Explore Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
